import { FC } from 'react';
import SignInComponent from './SignInForm';
import { metaTitle } from '../../../util/tabTitle';
import AuthShell from '../../auth/AuthShell';

const DisplaySignInPage: FC = () => {
  metaTitle('Sign In');
  return (
    <AuthShell
      title="Display access"
      subtitle="Enter your organization code to view available presentations."
    >
      <SignInComponent />
    </AuthShell>
  );
};

export default DisplaySignInPage;
